// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"12e720bd","453":"0af65dfc","732":"2c6de71b","977":"48a964d0"}[chunkId] + ".chunk.js";
};